/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import Skeleton from "@mui/material/Skeleton";

import { colors } from "@dotnet/telematics-design-system";

import { useStyles } from "./styles";

const PaginationLoader = ({ ...props }) => {
  const { paginationLoader } = useStyles();

  const paginationLoadersWidth = [
    { width: 36, id: 1 },
    { width: 36, id: 2 },
    { width: 20, id: 3 },
    { width: 20, id: 4 },
    { width: 20, id: 5 },
    { width: 36, id: 6 },
    { width: 36, id: 7 }
  ];

  return (
    <div
      data-testid="pagination-loader"
      {...props}
      css={css([
        {
          span: {
            background: colors.gray200
          }
        },
        paginationLoader
      ])}
    >
      {paginationLoadersWidth.map((loaderwidth: any) => (
        <Skeleton
          variant="rectangular"
          width={loaderwidth.width}
          key={loaderwidth.id}
        />
      ))}
    </div>
  );
};

export default PaginationLoader;
